import GenericError from 'components/GenericError/GenericError'
import Translation from 'components/Translation'
import { useTenantContext } from 'context/TenantContext'
import React, { useEffect, useState } from 'react'
import DashboardSettings from '..'
import SuccessModal from 'components/Modals/ErrorModal'
import {
    DEFAULT_ERROR_STATE,
    IError,
    useAppContext,
} from 'context/AppContext'
import { handleDBSettingsChange } from 'components/Modals/CustomBookingPage/BookingPageOptions'
import { getCurrencySymbol } from 'utils/string-localization-helper'

const PAYMENT_POLICY_OPTIONS = [
    {
        id: 1,
        title: 'Require a payment, valid coupon, or membership at booking time',
        value: 'allOptions',
        translationKey: 'all_options',
    },
    {
        id: 2,
        title: 'Payment at booking time is optional',
        value: 'optionalPayment',
        translationKey: 'optional_payment',
    },
    {
        id: 2,
        title: 'Do not allow payment at booking time',
        value: 'notAllowed',
        translationKey: 'payment_not_allowed',
    },
    {
        id: 3,
        title: 'Only allow payment in-person',
        value: 'inPerson',
        translationKey: 'payment_in_person',
    },
]

export const PAYMENT_POLICY_KEY = 'PAYMENT_POLICY'
export const DEFAULT_COMMISSION = 'DEFAULT_COMMISSION'

function PaymentPolicy() {
    const { db_settings, tenant, getDbSettings } = useTenantContext()
    const [selectedPolicy, setSelectedPolicy] = useState(
        PAYMENT_POLICY_OPTIONS[0].value
    )
    const [defaultCommission, setDefaultCommission] = useState('0')
    const [commissionType, setCommissionType] = useState<
        'PERCENT' | 'EXACT'
    >('PERCENT')
    const [error, setError] = useState<IError>(DEFAULT_ERROR_STATE)
    const [success, setSuccess] = useState('')
    const { translations } = useAppContext()

    useEffect(() => {
        handleDefaultPaymentPolicy()
        handleDefaultCommission()
    }, [db_settings])

    const handleDefaultPaymentPolicy = () => {
        const found = db_settings?.content?.find(
            (item: any) => item.name === PAYMENT_POLICY_KEY
        )
        if (found) {
            setSelectedPolicy(found?.value)
        }
    }

    const handleDefaultCommission = () => {
        const found = db_settings?.content?.find(
            (item: any) => item.name === DEFAULT_COMMISSION
        )
        if (found) {
            const splittedVal = found?.value?.split('-')
            setDefaultCommission(splittedVal[0])
            setCommissionType(splittedVal[1])
        }
    }

    const handlePaymentPolicy = () => {
        return handleDBSettingsChange(
            db_settings,
            PAYMENT_POLICY_KEY,
            selectedPolicy,
            tenant?.id as string
        )
    }

    const handleDefaultCommissionSave = () => {
        return handleDBSettingsChange(
            db_settings,
            DEFAULT_COMMISSION,
            `${defaultCommission}-${commissionType}`,
            tenant?.id as string
        )
    }

    const updatePaymentPolicy = async () => {
        const res = await handlePaymentPolicy()
        const res1 = await handleDefaultCommissionSave()
        console.log(res, 'ddd', res1)
        if (!!res?.ok && !!res1?.ok) setSuccess('payment_policy_updated')
        else {
            setError({
                message:
                    (res?.message as string) || (res1?.message as string),
                tag: res?.tag || res1?.tag,
            })
        }
        getDbSettings()
    }

    const isNumber =
        /^[0-9.,]+$/.test(defaultCommission) && +defaultCommission <= 100

    return (
        <DashboardSettings>
            <div className="p-5 h-loose flex flex-col">
                {!!error?.message?.length && (
                    <GenericError
                        error_message={error.message}
                        onCloseModal={() => setError(DEFAULT_ERROR_STATE)}
                        tag={error?.tag}
                    />
                )}
                {success?.length > 0 && (
                    <SuccessModal
                        type="success"
                        error_message={translations[success]}
                        onCloseModal={() => setSuccess('')}
                    />
                )}
                <div className="flex flex-col">
                    <label className="text-lg">
                        <Translation
                            content_key={
                                'payment_policy'
                            }
                        />{' '}
                    </label>
                    <select
                        className="text-black px-2 py-1 rounded-md mt-2 border-2 border-gray-200"
                        onChange={(e) => setSelectedPolicy(e.target.value)}
                        value={selectedPolicy}
                    >
                        {PAYMENT_POLICY_OPTIONS.map((item) => (
                            <option key={item.id} value={item.value}>
                                {translations[item?.translationKey]}
                            </option>
                        ))}
                    </select>
                </div>
                <div className="flex flex-col mt-3">
                    <div>
                        <label className="text-lg">
                            <Translation
                                content_key={
                                    'default_commission_rate'
                                }
                            />
                        </label>
                    </div>
                    <div className="border-2 border-gray-200 rounded-md flex items-center">
                        <select
                            className="h-full w-14 bg-gray-200"
                            defaultValue={commissionType}
                            onChange={(e) =>
                                setCommissionType(
                                    e.target.value as 'PERCENT' | 'EXACT'
                                )
                            }
                        >
                            <option
                                value={'PERCENT'}
                                selected={commissionType === 'PERCENT'}
                            >
                                {'%'}
                            </option>
                            <option
                                value={'EXACT'}
                                selected={commissionType === 'EXACT'}
                            >
                                {getCurrencySymbol()}
                            </option>
                        </select>
                        <input
                            className="text-black h-full w-full rounded-md px-5"
                            value={defaultCommission + ''}
                            onChange={(e) =>
                                setDefaultCommission(e.target.value)
                            }
                        />
                    </div>
                </div>
                <div className="mt-5">
                    <button className="px-2 py-1 border-2 border-gray-200 rounded-md">
                        <Translation content_key="cancel" />
                    </button>
                    <button
                        disabled={!isNumber}
                        className="bg-primary text-white border-2 border-primary rounded-md px-2 py-1 ml-2 disabled:bg-gray-200 disabled:cursor-not-allowed disabled:border-gray-200"
                        onClick={() => updatePaymentPolicy()}
                    >
                        <Translation content_key="save" />
                    </button>
                </div>
            </div>
        </DashboardSettings>
    )
}

export default PaymentPolicy
